import { isNull } from '@infl-ts/util-function';
import { pipe } from 'fp-ts/function';
import * as O from 'fp-ts/Option';
import * as Refine from 'fp-ts/Refinement';
import { UploadedFile } from '../../../file-uploader';
import MediaUploadFormField from '../../media-upload-form-field';
import { jsx as _jsx } from "react/jsx-runtime";
export var FileInput = function FileInput(_ref) {
  var name = _ref.name,
      _ref$required = _ref.required,
      required = _ref$required === void 0 ? false : _ref$required,
      _ref$questionForm = _ref.questionForm,
      control = _ref$questionForm.control,
      watch = _ref$questionForm.watch,
      setValue = _ref$questionForm.setValue,
      setError = _ref$questionForm.setError,
      clearErrors = _ref$questionForm.clearErrors,
      errors = _ref$questionForm.formState.errors;
  return pipe(watch(name), O.fromPredicate(Refine.or(isNull)(UploadedFile.is)), O.match(function () {
    //TODO(qlonik): Replace with LogRocket logging
    console.error('File Upload Question requires a file upload response');
    return null;
  }, function (fileResponse) {
    return /*#__PURE__*/_jsx(MediaUploadFormField, {
      control: control,
      name: name,
      required: required,
      acceptedMediaType: "file",
      onUploadSuccess: function onUploadSuccess(f) {
        clearErrors(name);
        setValue(name, f);
      },
      clearErrors: clearErrors,
      onUploadFailure: function onUploadFailure(message) {
        return setError(name, {
          type: 'manual',
          message: message
        });
      },
      removeFile: function removeFile() {
        return setValue(name, null);
      },
      file: fileResponse,
      error: errors[name]
    });
  }));
};